// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    filteredSearchFieldsStyle,
    filterHeaderStyle,
} from "@hardwoods/App/WidgetExtensions/MyAccountPagesSharedStyle/List.style";
import { filterStyles } from "@hardwoods/Overrides/Widgets/MyLists/MyListsFilter";
import { mergeWithCss } from "@hardwoods/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(filteredSearchFieldsStyle.containerWithPadding, {
        css: css`
            &.hide {
                display: none;
            }
        `,
    }),
};

filterStyles.headingItem = {
    css: css`
        display: none;
    `,
};

filterStyles.gridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        align-items: flex-end;
        & > div {
            flex-grow: 1;
            padding: 0;
        }
    `,
};

filterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

filterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

filterStyles.clearFiltersButton = {
    ...filterHeaderStyle.clearFiltersButton,
};
